import {
  CardResponse,
  Language as AreenaApiLanguage
} from "@yleisradio/areena-types";

import { contentTypeToService } from "../helpers/areenaApi";
import { isYleEmbed } from "../helpers/commonUtils";
import { getJson } from "../helpers/request";
import { tunnusExists } from "../hooks/useLoginData/useLoginData";
import { ContentType } from "../types/player-api";

export const recommendationsUrl = (
  programId: string,
  contentType: ContentType
): string =>
  `${__AREENA_API}/v1/ui/recommendations/${contentTypeToService(contentType)}/items/${programId}`;

const numberOfRecommendations = 4;

const getLanguageParameter = (lang: string): AreenaApiLanguage =>
  lang === "swe" ? "sv" : "fi";

const queryOptions = (
  programId: string,
  contentType: ContentType,
  language: string
) => {
  return {
    parameters: {
      client: "yle-areena-web",
      language: getLanguageParameter(language),
      limit: numberOfRecommendations,
      v: 10
    },
    url: recommendationsUrl(programId, contentType),
    withCredentials: tunnusExists() || isYleEmbed()
  };
};

export const fetchRecommendations = async (
  programId: string,
  contentType: ContentType,
  language: string
): Promise<CardResponse> => {
  try {
    const cardResponse = await getJson<CardResponse>(
      queryOptions(programId, contentType, language)
    );

    return cardResponse;
  } catch (e) {
    console.warn("Failed to fetch recommendations", e);
    return { data: [] };
  }
};
